// An unfinished application is kept in this browser so a person can close
// the tab and pick up where they left off. Storage can be missing or throw
// (private mode, blocked site data), so every access is guarded and the form
// works the same without it.

const PREFIX = "nandos-careers:draft:";
const KEEP_FOR_MS = 14 * 24 * 60 * 60 * 1000;

const storage = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

const keyFor = (slug) => `${PREFIX}${slug}`;

export function loadDraft(slug, now = Date.now()) {
  try {
    const raw = storage()?.getItem(keyFor(slug));
    if (!raw) return null;
    const draft = JSON.parse(raw);
    if (!draft?.savedAt || now - draft.savedAt > KEEP_FOR_MS) {
      clearDraft(slug);
      return null;
    }
    return draft;
  } catch {
    return null;
  }
}

export function saveDraft(slug, draft, now = Date.now()) {
  try {
    storage()?.setItem(keyFor(slug), JSON.stringify({ ...draft, savedAt: now }));
  } catch {
    // Quota or privacy mode: the form still works, it just won't be kept.
  }
}

export function clearDraft(slug) {
  try {
    storage()?.removeItem(keyFor(slug));
  } catch {
    // Nothing to clear.
  }
}

// A draft is worth offering back only if the person actually typed something.
// (The phone field always holds a default country, so only its number counts.)
export const hasProgress = (draft) =>
  Boolean(draft?.values) &&
  Object.entries(draft.values).some(([key, value]) => {
    if (key === "answers") return false;
    if (key === "phone") return Boolean(value?.number);
    return typeof value === "string" && value !== "";
  });
